import React, { Component } from "react";
import ReactGA from "react-ga";
import BannerImg from "../../assets/images/banner/dotnetnuke-development.png";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

class DotNetNukeDevelopment extends Component {
  state = {};
  render() {
    ReactGA.initialize("UA-5235714-2");
    ReactGA.pageview(window.location.pathname + window.location.search);
    return (
      <React.Fragment>
        <Helmet defer={false}>
          <title>DotNetNuke (DNN) Development & CMS Modernization Heritage | Avani Cimcon</title>
          <meta
            name="keywords"
            content="DotNetNuke (DNN), DNN, dotnetnuke development, dotnetnuke modules, dotnetnuke portal, dotnetnuke hosting, DNN services, DNN skin, DNN India, DNN outsource, .net TreeView, .net Combo, .net List, .net Image, .net CustomModule, CMS modernization, legacy platform modernization, software development services, IT services, enterprise content management"
          />
          <meta
            name="description"
            content="DotNetNuke is part of Avani Cimcon's CMS and portal engineering heritage. The experience still matters today for legacy modernization, content platforms, and enterprise software evolution."
          />
          <link rel="canonical" href="https://www.avanicimcon.com/dotnetnuke-development" />
        </Helmet>
        <div className="page-banner d-flex align-items-center justify-content-center text-white">
          <div className="page-title container position-relative">
            <h1 className="font-weight-bold text-uppercase">DotNetNuke Development</h1>
            <h5>Legacy platform modernization heritage</h5>
          </div>
          <div className="page-banner-img" style={{ backgroundImage: `url("${BannerImg}")` }}></div>
          <div className="page-banner-overlay"></div>
        </div>

        <div className="inner-page mt-5 mb-5 ">
          <div className="container">
            <div className="text-justify">
              <p className="font-weight-bold text-primary">
                DotNetNuke experience is part of our CMS modernization heritage. It reflects the
                kind of portal and content platform engineering depth that still matters when
                enterprises need to extend, migrate, or modernize existing systems safely.
              </p>
              <p>
                DotNetNuke is one of the fast emerging technologies in the Content Management
                systems. Avani Cimcon Technologies has been a pioneer in this DotNetNuke technology.
                With our more that 3 years of experience we provide the best possible DotNetNuke
                Solutions using this ever-evolving technology.
              </p>

              <p>
                Our DotNetNuke Modules have been built using AJAX Technology. This allows for an
                enhanced user interface experience and is extremely fast and efficient in
                presentation of data. We mould our products and services in DotNetNuke on the basis
                of our experience in executing projects, developing custom systems and our
                experience in WYSIWYG User Interfaces. We build DotNetNuke modules that are
                practical and can be productive right from time of installation.
              </p>

              <p>
                After having worked on numerous DotNetNuke modules and DotNetNuke projects, we
                decided that a tree interface could easily be the most usable interface globally
                because unless otherwise specified, all interfaces can be displayed in a Tree
                categorizing and sub-categorizing it.
              </p>

              <h5 className="text-primary mt-4 mb-3">
                Some of our DotNetNuke modules are listed below:
              </h5>

              <ul>
                <li className="mb-2">ACTL.netTree</li>
                <li className="mb-2">ACTL.netCombo</li>
                <li className="mb-2">ACTL.netCustomModule</li>
                <li className="mb-2">ACTL.netImage</li>
                <li className="mb-2">ACTL.netList</li>
                <li>ACTL.TextHTNL</li>
              </ul>

              <div className="mt-4 p-4 bg-light border rounded">
                <h5 className="text-primary mb-3">Why legacy CMS experience still matters</h5>
                <ul className="mb-0">
                  <li className="mb-2">
                    <Link to="/cms">Use CMS heritage to guide safer platform and content modernization</Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/it-consulting-services">Apply portal and migration experience to modernization planning</Link>
                  </li>
                  <li>
                    <Link to="/contact-us">Discuss a DotNetNuke migration or legacy CMS program</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default DotNetNukeDevelopment;
